module.exports = __webpack_public_path__ + "img/LATIN10_11.3bf0f000.jpg";